import { z } from "zod";

export const classificationRuleSchema = z.object({
  id: z.number().int(),
  category: z.string(),
  value: z.string(),
  targets: z.array(z.string()),
  weight: z
    .number()
    .int()
    .min(-5, "Weight must be between -5 and 5")
    .max(5, "Weight must be between -5 and 5"),
  isActive: z.boolean(),
  keywords: z.array(z.string()),
  dashboardColumn: z.string().optional(),
});

export const createClassificationRuleRequestSchema = z.object({
  category: z.string().min(1, "Category is required"),
  value: z.string(),
  targets: z.array(z.string()),
  weight: z
    .number()
    .int()
    .min(-5, "Weight must be between -5 and 5")
    .max(5, "Weight must be between -5 and 5"),
  keywords: z.array(z.string()),
});

export const updateClassificationRuleRequestSchema = z.object({
  value: z.string().min(1, "Value is required"),
  weight: z
    .number()
    .int()
    .min(-5, "Weight must be between -5 and 5")
    .max(5, "Weight must be between -5 and 5"),
  isActive: z.boolean(),
  keywords: z.array(z.string()),
});

export const addKeywordsRequestSchema = z.object({
  keywords: z.array(z.string()).min(1, "At least one keyword is required"),
});

export const classificationRuleCategorySchema = z.object({
  name: z.string(),
  displayName: z.string(),
  description: z.string(),
  isSingleton: z.boolean(),
  requiresValue: z.boolean(),
});

export const classificationRuleCategoriesResponseSchema = z.array(
  classificationRuleCategorySchema
);
